import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { COUNTRY_CODES } from "../utils/phoneCountryCodes";

export default function CountryPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = COUNTRY_CODES.find((c) => c.code === value) || COUNTRY_CODES[0];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1.5 h-full px-3 py-3 border rounded-xl bg-white transition outline-none cursor-pointer
          ${open ? "border-indigo-400 ring-2 ring-indigo-200" : "border-gray-300 hover:border-gray-400"}`}
      >
        <span className="text-2xl leading-none">{selected.flag}</span>
        <span className="text-sm font-bold text-gray-700 tabular-nums">{selected.code}</span>
        <ChevronDown size={13} className={`text-gray-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      <AnimatePresence>
        {open && (
          <motion.ul
            initial={{ opacity: 0, y: -6, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -6, scale: 0.97 }}
            transition={{ duration: 0.14 }}
            className="absolute top-full left-0 mt-1.5 z-50 bg-white border border-gray-200 rounded-2xl shadow-xl overflow-hidden min-w-[180px]"
          >
            {COUNTRY_CODES.map((c) => (
              <li key={c.code}>
                <button
                  type="button"
                  onClick={() => { onChange(c.code); setOpen(false); }}
                  className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-indigo-50 transition text-left
                    ${c.code === value ? "bg-indigo-50 font-bold text-indigo-700" : "text-gray-700"}`}
                >
                  <span className="text-xl leading-none">{c.flag}</span>
                  <span className="flex-1">{c.name}</span>
                  <span className="tabular-nums text-gray-400 font-semibold text-xs">{c.code}</span>
                </button>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
}
